import {
    AlertOutlined,
    ApartmentOutlined,
    AppstoreAddOutlined,
    AreaChartOutlined,
    AuditOutlined,
    BookOutlined,
    CodeSandboxOutlined,
    ControlOutlined,
    CopyOutlined,
    CreditCardOutlined,
    DeleteOutlined,
    ExportOutlined,
    FieldNumberOutlined,
    FilePptOutlined,
    FileSyncOutlined,
    FileTextOutlined,
    FilterOutlined,
    FlagOutlined,
    FundOutlined,
    HomeOutlined,
    ImportOutlined,
    PartitionOutlined,
    PrinterOutlined,
    RedoOutlined,
    SearchOutlined,
    ShopOutlined,
    SwapOutlined,
    SyncOutlined,
} from "@ant-design/icons";
import type { FC } from "react";
import * as React from "react";

import { IconCodes } from "./IconCodes";

/**
 * for more info about antd Icon props @see https://ant.design/components/icon/#Common-Icon
 */
type AntIconProps = Readonly<{
    /** if is set true icon start rotate. Useful for loading. */
    spin?: boolean;
    /** mainly for pass className from styled-component */
    className?: string;

    style?: React.CSSProperties;
}>;

/**
 * Properties of the Icon component
 * */
export type IconProps = Readonly<{
    iconName: IconCodes;
}> &
    AntIconProps;

/**
 * Mapping of the icon resource to the enum for better autocompletion
 * */
const AllIcons: Readonly<Record<IconCodes, FC<AntIconProps>>> = {
    [IconCodes.AlertOutlined]: AlertOutlined,
    [IconCodes.ApartmentOutlined]: ApartmentOutlined,
    [IconCodes.AreaChartOutlined]: AreaChartOutlined,
    [IconCodes.AuditOutlined]: AuditOutlined,
    [IconCodes.BookOutlined]: BookOutlined,
    [IconCodes.ControlOutlined]: ControlOutlined,
    [IconCodes.CreditCardOutlined]: CreditCardOutlined,
    [IconCodes.FieldNumberOutlined]: FieldNumberOutlined,
    [IconCodes.FilePptOutlined]: FilePptOutlined,
    [IconCodes.FileSyncOutlined]: FileSyncOutlined,
    [IconCodes.FileTextOutlined]: FileTextOutlined,
    [IconCodes.FundOutlined]: FundOutlined,
    [IconCodes.HomeOutlined]: HomeOutlined,
    [IconCodes.PartitionOutlined]: PartitionOutlined,
    [IconCodes.PrinterOutlined]: PrinterOutlined,
    [IconCodes.FlagOutlined]: FlagOutlined,
    [IconCodes.CodeSandboxOutlined]: CodeSandboxOutlined,
    [IconCodes.DeleteOutlined]: DeleteOutlined,
    [IconCodes.CopyOutlined]: CopyOutlined,
    [IconCodes.ShopOutlined]: ShopOutlined,
    [IconCodes.SyncOutlined]: SyncOutlined,
    [IconCodes.SwapOutlined]: SwapOutlined,
    [IconCodes.FilterOutlined]: FilterOutlined,
    [IconCodes.ExportOutlined]: ExportOutlined,
    [IconCodes.ImportOutlined]: ImportOutlined,
    [IconCodes.AppstoreAddOutlined]: AppstoreAddOutlined,
    [IconCodes.RedoOutlined]: RedoOutlined,
    [IconCodes.SearchOutlined]: SearchOutlined,
};

/**
 * Generic component for displaying the icons from antd.
 * @param iconName Name of the icon from antd library
 * @param className
 * @param style
 * */
export const Icon: FC<IconProps> = ({ iconName, className, style }) => {
    const Component = AllIcons[iconName];
    return <Component className={className} style={style} />;
};
